<template>
<!-- 仓小微支付页面 -->
<div class="main">
	<div class="title">{{info.productName}}</div>
	<Steps :current="2" style="margin:20px auto; width:700px;padding-left:116px">
		<Step title="申请信息"></Step>
		<Step title="确认信息"></Step>
		<Step title="支付"></Step>
	</Steps>
	<div class="order">
		<div class="order-title">订单信息</div>
		<Table :columns="columns" border :data="orderData">
			<template slot-scope="{ row, index }" slot="productName">
				<b style="font-size:16px;">{{row.productName}}</b>
			</template>
			<template slot-scope="{ row, index }" slot="payPrice">
				<div class="price">
					<p>
						<span class="price-label">订单金额：</span>
						<span class="price-value">{{row.totalAmount}}元</span>
					</p>
				</div>
			</template>
		</Table>
	</div>
	<div class="center fz16" v-if="info.orderStatus=='UNPAID'">当天24时前未完成支付订单，将自动关闭。</div>
	<div class="center fz16" v-if="info.orderStatus&&info.orderStatus!='UNPAID'">支付状态：{{info.orderStatusDesc}}</div>
	<Row class="mt15" v-if="info.orderStatus=='UNPAID'">
		<Col span="12" offset="9">
			<Form ref="form">
				<FormItem label="支付方式：">
					<RadioGroup v-model="payType" @on-change="payTypeChange" >
						<Radio :label="item.key" :disabled="Boolean(info.payVoucherUrl)" v-for="(item, index) in payTypeList" :key="index">{{item.value}}</Radio>
					</RadioGroup>
				</FormItem>
				<FormItem :labelWidth="80" v-show="payType=='THIRD_PARTY_ONLINE'">
					<p style="font-size:14px;font-weight:500;">
						点击支付后，将跳转至第三方收银台平台进行支付，支付完成后关闭页面即可
					</p>
					<Button type="primary" @click="tolink">立即支付</Button>
				</FormItem>
			</Form>
			<div class="pay" v-show="payType&&payType!=='PUBLIC_BANK'&&payType!='THIRD_PARTY_ONLINE'">
				<div class="code">
					<div id="qrcode" v-show="!loading"></div>
					<p>
					请使用
					<span v-if="payType==item.key" v-for="(item, index) in payTypeList" :key="index">{{item.value}}</span>
					扫码支付
					</p>
				</div>
			</div>
			<div v-if="payType=='PUBLIC_BANK'" class="publicPay">
				<p class="note">选择对公支付的会员，请及时付款至以下指定账户，平台会根据您已提交的信息生成各类投保订单。</p>
				<div class="form">
					<template v-if="info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'">
						<p>
							<span class="form-label">名称：</span>
							<span class="form-value">中国平安财产保险股份有限公司青岛分公司</span>
						</p>
						<p>
							<span class="form-label">开户行：</span>
							<span class="form-value">平安银行青岛分行</span>
						</p>
						<p>
							<span class="form-label">账号：</span>
							<span class="form-value">11012728033801</span>
						</p>
						<p>
							<span class="form-label">联系人：</span>
							<span class="form-value">王乔 19538345769</span>
						</p>
					</template>
					<template v-else>
						<p>
							<span class="form-label">名称：</span>
							<span class="form-value">青岛海尔保险代理有限公司</span>
						</p>
						<p>
							<span class="form-label">开户行：</span>
							<span class="form-value">中国建设银行青岛市分行海尔路支行</span>
						</p>
						<p>
							<span class="form-label">账号：</span>
							<span class="form-value">37101985510050404761</span>
						</p>
						<p>
							<span class="form-label">联系人：</span>
							<span class="form-value">郑晓宁（zhengxn.qdkt@haier.com）</span>
						</p>
					</template>
					<p class="red">
						<span class="form-label">注意：</span>
						<span class="form-value">1、对公支付，在付款后，请上传支付凭证。<b>当天24时前未完成支付订单，将自动关闭。</b></span>
					</p>
					<p class="red">
						<span class="form-label"></span>
						<span class="form-value">2、确认收到款项后，会向手机号{{info.phone}}发送短信</span>
					</p>
					<p class="red">
						<span class="form-label"></span>
						<span class="form-value">3、对公付款时请备注以下信息，否则会影响承保</span>
					</p>
					<p class="mt15">
						<span class="form-label"></span>
						<span class="form-value">
							{{info.applicantName}}+{{info.productName}}
							<Button
							type="primary"
							size="small"
							@click="copy"
							class="copyBtn"
							:data-clipboard-text="`${info.applicantName}+${info.productName}`"
							>复制</Button>
						</span>
					</p>
					<p class="mt15">
						<span class="form-label"></span>
						<UploadFile @on-success="handleSuccess" type="select">
							<Button type="primary">上传支付凭证</Button>
						</UploadFile> 
						<a @click="openOriginFile(info.payVoucherUrl)" v-if="info.payVoucherUrl">查看文件</a>
					</p>
					<p class="mt15">
						<span class="form-label"></span>
						<Button type="success" @click="confirmUpload" :disabled="!Boolean(info.payVoucherUrl)">提交凭证</Button>
					</p>
				</div>
			</div>
		</Col>
	</Row>
</div>
</template>
<script>
import QRCode from "qrcodejs2";
import Clipboard from "clipboard";
import UploadFile from '@/components/common/UploadFileImg'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{UploadFile},
	data() {
		return {
			columns: [
				{
					title: "产品名称",
					key: "productName",
					slot: "productName"
				},
				{
					title: "订单号",
					key: "orderNo"
				},
				{
					title: "订单创建时间",
					key: "createTime"
				},
				{
					title: "支付",
					slot: "payPrice",
					width: 300
				}
			],
			orderData: [],
			info: {},
			clock: undefined,
			flag: true,
			use: true,
			payType: "",
			orderNo:this.$route.params.id,
			qrcode:null,
			loading:false,
			payTypeList:[]
		};
	},
	created() {
		this.getOrderInfo();
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	methods: {
		// 跳转第三方支付
		tolink(){
			this.$Modal.confirm({
				title: '提示',
				content: `是否确认跳转？`,
				onOk: () => {
					const newPage = window.open(); // 打开一个不被拦截的空白窗口
					this.$axios.post('/broker/order/payUrl',{
						orderNo:this.orderNo,
						paymentSource: this.payType,
					}).then(async res=>{
						if(res){
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
							});
							this.checkStatus();
							newPage.location.href = res // 修改空白窗口的url
						}
					})
				},
				onCancel: () => {
				}
			});
		},
		// 获取付款方式
		getPayType(){
			this.$axios.post('/broker/product/paymentSourceOptionalList',{
				productCode:this.info.productCode
			}).then(res=>{
				if(this.info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'){
					this.payTypeList = [{key:'PUBLIC_BANK',value:'平安对公支付'}];
				} else {
					this.payTypeList=res;
				}
			});	
		},
		// 获取订单信息
		getOrderInfo() {
			this.$axios.post('/broker/order/detail',{
				orderNo:this.orderNo
			}).then(res=>{
				this.info = res;
				if(this.info.bizId=='JIANGONG_DEPOSIT'){
					this.payType = 'THIRD_PARTY_ONLINE';// 第三方支付
				}
				this.info.applicantName=(res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}).subjectName
				this.orderData=[res];
				this.getPayType();
				// 货车雇主按人
				if(this.info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'){
					this.payType = 'PUBLIC_BANK';// 对公支付
				}
				if(this.info.orderStatus=='UNPAID'){
					// 待支付
					if(res.insuranceApplicationId){
						this.getPolicyInfo(res.insuranceApplicationId,'application')
					}else{
						this.getPolicyInfo(res.insurancePolicyId,'policy')
					}
					
				}
			});
		},
		// 获取投保单信息
		getPolicyInfo(id,type){
			let url=type=='application'?'/broker/insurance/application/detail':'/broker/insurance/policy/detail'
			this.$axios.post(url,{
				applicationId:id,
				insurancePolicyId:id
			}).then(res=>{
				this.info.phone=res.applicantList&&res.applicantList.length>0?res.applicantList[0].contactPhone:''
			});
		},
		// 获取二维码url
		getQrCodeUrl(){
			return this.$axios.post('/broker/order/payUrl',{
				orderNo:this.orderNo,
				paymentSource:this.payType
			})
		},
		// 获取二维码
		async getQrCode() {
			let payItem=this.payTypeList.find(item=>{
				return item.key==this.payType
			})
			if(payItem&&!payItem.payUrl){
				payItem.payUrl=await this.getQrCodeUrl()
			}
			if(!this.qrcode){
				this.qrcode = new QRCode("qrcode", {
					width: 200,
					height: 200, // 高度
					text: payItem.payUrl // 二维码内容
				});
			}else{
				this.qrcode.makeCode(payItem.payUrl)
			}
			this.checkStatus();
		},
		/*检查支付状态*/
		checkStatus() {
			this.clock = setInterval(() => {
				if (this.flag) {
					this.flag = false;
					this.$axios.post('/broker/order/detail.no',{
						orderNo:this.orderNo
					}).then(async res=>{
						if(res.orderStatus=='PAID'&&res.bizId!='JIANGONG_DEPOSIT'){
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
							});
							clearInterval(this.clock);
							window.location.href = `/haierProduct.html#/my/order-detail/${this.orderNo}/common`;
						} else if(res.orderStatus=='PAID'&&res.bizId=='JIANGONG_DEPOSIT') {
							clearInterval(this.clock);
							this.info = res;
							if(res.bizId=='JIANGONG_DEPOSIT'){
								this.payType = 'THIRD_PARTY_ONLINE';// 第三方支付
							}
						}
						this.flag = true;
					}).catch(res=>{
						this.flag = true;
					})
				}
			}, 3000);
		},
		// 清除循环
		clearCheckStatus() {
			clearInterval(this.clock);
		},
		// 切换支付方式
		payTypeChange() {
			this.clearCheckStatus();
			if (this.payType !== "PUBLIC_BANK") {
				this.getQrCode();
			}
		},
		// 复制
		copy() {
			let clipboard = new Clipboard(".copyBtn");
			clipboard.on("success", e => {
				this.toast("复制成功"); // 释放内存
				clipboard.destroy();
			});
			clipboard.on("error", e => {
				// 不支持复制
				this.alert("该浏览器不支持自动复制"); // 释放内存
				clipboard.destroy();
			});
		},
		// 上传成功
		handleSuccess(val){
			this.$set(this.info,'payVoucherUrl',val.url)
		},
		confirmUpload(){
			this.confirm('确定提交已上传凭证？',()=>{
				this.$axios.post('/broker/order/upload/payVoucher',{
					orderNo:this.orderNo,
					payVoucherUrl:this.info.payVoucherUrl,
				}).then(async res=>{
					// 回溯 停止录制
					await this.stopRecord({
						policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
					});
					window.location.href=`/common.html#/pay-success/${this.orderNo}?phone=${this.info.phone}&type=common`
				});
			})
		}
	}
};
</script>
<style scoped lang="less">
.main {
	padding: 20px 30px;
}
.order-title {
	font-size: 14px;
	margin-bottom: 10px;
}
.center {
	font-size: 25px;
	font-weight: bold;
	margin-top: 15px;
	color: #ff6600;
}
.pay {
	margin-top: 10px;
	display: flex;
	justify-content: center;
	text-align: center;
	width: 200px;
	margin-left: 45px;
}
.fz16{
	font-size: 16px;
}
.code > p {
	margin-top: 15px;
}
.price {
	font-size: 16px;
	&-label {
		width: 7em;
		display: inline-block;
		line-height: 2;
		text-align: right;
		font-size: 16px;
		&.small{
			width: 92px;
		}
	}
	&-value {
		color: red;
		font-size: 16px;
		&.disabled{
			color: #999;
			text-decoration: line-through;
		}
	}
}
.form {
	margin-top: 10px;
	font-size: 14px;
	&-label {
		width: 5em;
		display: inline-block;
		line-height: 2;
		text-align: right;
	}
	.red {
		color: red;
	}
}
.publicPay {
	.note {
		font-size: 12px;
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/IndexCommon.vue